<template>
  <el-table-column
    prop="receipt_number"
    sortable="custom"
    label="Iktató szám"
    show-overflow-tooltip
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.receipt_number }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'receipt_number',
};
</script>
